import _ from 'lodash';
import moment from 'moment';
import { LIST_STORES_ACCEPT_SHOW_APP_VERSION_SWITCHING } from 'src/constants/accounts';
import { RELEASE_SIMPLIFY_DATE } from 'src/constants/dashboard-v4';
import { EXCLUDED_PLANS } from 'src/helpers/subscription-v4-helper';

/**
 * Check if store could show turbo switching
 * @param {*} tenantApp
 * @returns
 */
export const checkUserEnableShowAppVersionSwitching = tenantApp => {
  const { tenantId, firstInstalledAt = '', status = '' } = tenantApp;
  const enableAppVersionSwitching = _.get(
    tenantApp,
    'settings.appSwitchingVersion.settings.enable'
  );

  //Check from settings before list because, in the future, several store could be settings false, and store still in the list

  if (typeof enableAppVersionSwitching === 'boolean') return enableAppVersionSwitching;

  if (LIST_STORES_ACCEPT_SHOW_APP_VERSION_SWITCHING.includes(tenantId)) {
    return true;
  }

  // Release for store using theme setup v3, from 2023-04-19 -> 2024-04-10 (phase 2)
  // if (firstInstalledAt >= 1681837200 && firstInstalledAt <= 1712682000 && status === 'active') {
  //   return true;
  // }

  // Release for all store except new ssr user (phase 3)
  if (firstInstalledAt <= 1712682000 && status === 'active') {
    return true;
  }

  return false;
};

/**
 * Check if store show which rating
 * @param {*} tenantApp
 * @returns
 */
export const isNewFreemiumUserForRating = tenantApp => {
  const { firstInstalledAt = '', status = '' } = tenantApp;

  // User installed after 01/07/2024 is new user (staging)   // 1719795600
  // User installed after 21/08/2024 is new user (production) // 1724223600

  if (
    firstInstalledAt >= (process.env.REACT_APP_ENV === 'production' ? 1724223600 : 1719795600) &&
    status === 'active'
  ) {
    return true;
  }

  return false;
};

/**
 * Check if store show which flow SI
 * @param {*} tenantApp
 * @returns
 */
export const isNewUserForSimplifySI = tenantApp => {
  const { firstInstalledAt = '', status = '' } = tenantApp;

  // User installed after 12/11/2024 is new user (staging)   // 1731369600
  // User installed after 08/01/2025 is new user (production) // 1736294400

  if (firstInstalledAt >= RELEASE_SIMPLIFY_DATE && status === 'active') {
    return true;
  }

  return false;
};

export const isExpireStore = tenantApp => {
  const trialExpired = _.get(tenantApp, 'trialExpired');
  const trialExpiredAt = _.get(tenantApp, 'trialExpiresAt');
  const current = moment();
  const momentTrialExpire = moment.unix(trialExpiredAt);
  const shopifyPlan = _.get(tenantApp, 'externalInfo.plan_name', '');
  const selectedPlan = _.get(tenantApp, 'selectedPlan', '');

  const isExpire =
    (selectedPlan === '' || selectedPlan.includes('freemium')) &&
    (trialExpired ||
      (current.isSameOrAfter(momentTrialExpire) && EXCLUDED_PLANS.includes(shopifyPlan))); // check expire for store dev, affiliate, etc.

  return isExpire;
};
export const isAllowSubscribePlanOnboarding = (tenantApp, syncOrderSuccess = false) => {
  const boltOn = _.get(tenantApp, 'boltOn', {});
  const useBoltOn = boltOn.status === 'active';
  if (useBoltOn) return false;
  // Check enable subscription V5 and sync order success
  if (_.get(tenantApp, 'settings.subscriptionV5.settings.enable', false)) {
    return syncOrderSuccess;
  }
  // for subscription v4 or lower version
  // https://clearerio.atlassian.net/wiki/spaces/CodaBoost/pages/32506525/Request+merchant+to+choose+plan+right+after+installation
  return _.get(tenantApp, 'settings.onboardingSubscription.settings.enable', false);
};
